import { render, staticRenderFns } from "./VideoLoader.vue?vue&type=template&id=082986e2&scoped=true&"
import script from "./VideoLoader.vue?vue&type=script&lang=js&"
export * from "./VideoLoader.vue?vue&type=script&lang=js&"
import style0 from "./VideoLoader.vue?vue&type=style&index=0&id=082986e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082986e2",
  null
  
)

export default component.exports